import type { RefObject } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { hiddenDown } from '@twistopayments/design-system/styles'

import { useHighlightedText } from 'homepage/libs/hooks'

import { BlogListControls } from '../blog-list-controls'

import * as styles from './blog-list-navigation.styles'

type BlogListNavitionProps = {
  title?: string
  highlighted?: string
  isTitleCentered?: boolean
  hasControls?: boolean
  containerRef?: RefObject<HTMLDivElement>
}

export const BlogListNavigation = ({
  title,
  highlighted,
  isTitleCentered,
  hasControls,
  containerRef,
}: BlogListNavitionProps) => {
  const { after, before, highlight } = useHighlightedText(title, highlighted)

  return (
    <div css={styles.navigation}>
      <Typography
        css={[styles.title, isTitleCentered && styles.centered]}
        fontWeight="heavy"
        variant="h2"
      >
        {before}
        <span css={styles.highlighted}>{highlight}</span>
        {after}
      </Typography>

      {hasControls && containerRef && (
        <div css={hiddenDown('smMd')}>
          <BlogListControls containerRef={containerRef} />
        </div>
      )}
    </div>
  )
}
